const countries = [
    { value: "Denmark", label: "Denmark" },
    { value: "Sweden", label: "Sweden" },
    { value: "Norway", label: "Norway" },
    { value: "Germany", label: "Germany" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
    { value: "Australia", label: "Australia" },
    { value: "Andorra", label: "Andorra" },
    { value: "Austria", label: "Austria" },
    { value: "Belgium", label: "Belgium" },
    { value: "Brazil", label: "Brazil" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "Greece", label: "Greece" },
    { value: "Iceland", label: "Iceland" },
    { value: "Ireland", label: "Ireland" },
    { value: "Italy", label: "Italy" },
    { value: "Japan", label: "Japan" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Malta", label: "Malta" },
    { value: "Monaco", label: "Monaco" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "Portugal", label: "Portugal" },
    { value: "San Marino", label: "San Marino" },
    { value: "Spain", label: "Spain" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "China", label: "China" }
  ];
  
  export default countries;
  


// WEBPACK FOOTER //
// ./src/c/countries/CountriesEn.js